!function(e, t) {
    'object' === typeof exports && 'undefined' !== typeof module ? module.exports = t() : 'function' === typeof define && define.amd ? define(t) : (e = 'undefined' !== typeof globalThis ? globalThis : e || self).dayjs_plugin_localizedFormat = t();
}(this, function() {
    'use strict';
    const e = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    return function(t, o, n) {
        const r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = 'YYYY-MM-DDTHH:mm:ssZ');
            const o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    const i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

//# sourceMappingURL=public.78f79af3.js.map
